// extracted by mini-css-extract-plugin
export default {"customTooltip":"tooltip_customTooltip__d7jWX"};